export interface BaseJwtPayload {
    exp?: number; // standard claim: expiration time
    iat?: number; // issued at
    iss?: string; // issuer
    sub?: string; // subject
    aud?: string; // audience
}

export interface PaymentPayload extends BaseJwtPayload {
    upoAmount: {
        value: number;
        currency?: string;
    };
}

export const AIRWALLEX_STATUS = {
    REQUIRES_PAYMENT_METHOD: 'REQUIRES_PAYMENT_METHOD',
    AUTHORIZED: 'AUTHORIZED',
    FAILED: 'FAILED',
    CAPTURE_REQUESTED: 'CAPTURE_REQUESTED',
    REQUIRES_ACTION: 'REQUIRES_ACTION',
} as const;

export type AirwallexStatus =
    (typeof AIRWALLEX_STATUS)[keyof typeof AIRWALLEX_STATUS];
